module.exports = __webpack_public_path__ + "img/cash_nl500.305a32f9.png";